import { StyleSheet } from 'react-native'

export const ThemedLayoutStyles = StyleSheet.create({
	scrollViewContentContainerStyle: {
		flexGrow: 1,
		justifyContent: 'flex-start',
	},
	scrollViewContentStyle: {
		flex: 1,
		flexGrow: 1,
		backgroundColor: 'transparent',
		marginBottom: 63,
	},
	scrollViewContentNoFooterBarStyle: {
		marginBottom: 0
	},
	parentStyle: {
		flex: 1,
		backgroundColor: 'transparent',
	}
});
